// components/OtpVerification.js
import React, { useState } from "react";
import axios from "axios";
import { toast } from 'react-toastify'; // Import toast from react-toastify
import 'react-toastify/dist/ReactToastify.css'; // Import toast CSS
const apiBase = process.env.REACT_APP_API;

const OtpVerification = ({ phoneNumber, setOtpVerified , email}) => {
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleVerifyOtp = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post(`${apiBase}/reset-password/verify-otp`, {
        phone_number: phoneNumber,
        otp: otp,
      });
      localStorage.setItem("RP_token", response.data.RP_token);
      toast.success(response.data.message);
      setOtpVerified(true);
    } catch (error) {
      setError(error.response?.data?.message || "OTP verification failed");
    }finally{
        setIsLoading(false);
    }
  };

  return (
    <div className="bg-white p-6 rounded shadow-lg w-80">
      <h2 className="text-2xl font-bold mb-4">Verify OTP</h2>
      <p>An OTP has been sent to {email}</p>
      <br />
      <input
        type="text"
        placeholder="Enter OTP"
        value={otp}
        onChange={(e) => setOtp(e.target.value)}
        className="w-full p-2 border border-gray-300 rounded mb-4"
        disabled={isLoading}
      />
      <button
        onClick={handleVerifyOtp}
        className={`w-full p-2 rounded text-white ${isLoading ? "bg-gray-400" : "bg-green-500 hover:bg-green-600"}`}
        disabled={isLoading}
      >
        {isLoading ? (
          <div className="flex items-center justify-center">
            <svg
              className="animate-spin h-5 w-5 mr-2 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
              ></path>
            </svg>
            Verifying...
          </div>
        ) : (
          "Verify OTP"
        )}
      </button>
      {error && <p className="text-red-500 mt-2">{error}</p>}
    </div>
  );

};

export default OtpVerification;
